import Vue from 'vue';
import Vuex from 'vuex';
import appSettings from '../assets/appSettings_parser_v4.json';
import { updateUserSettingsApi } from '../services/user.service';
import { getUserDatabases } from '../services/userTable';
import { getFlowTaskDataObject } from '../utils/helpers';

Vue.use(Vuex);

// eslint-disable-next-line no-unused-vars
const standardSettings = {
  isLimitLoadEditToDateInterval: false,
  isLimitLoadEditToTimeInterval: false,
  isLimitLoadEditToDayInterval: false,
};

const initialState = {
  user: null,
  appSettings: appSettings,
  userSettings: null,
  addNewFlowPermission: false,
  flows: [],
  databaseItems: {},
  isLoading: false,
  isAdmin: false,
  isDatabaseDragging: false,
  databaseList: [],
};

const store = new Vuex.Store({
  // eslint-disable-next-line no-undef
  state: structuredClone(initialState),
  getters: {
    getAllFlows(state) {
      return state.flows;
    },
    getJWTToken(state) {
      return state.user
        ? state.user.signInUserSession.accessToken.jwtToken
        : null;
    },
    getUser(state) {
      return state.user;
    },
    getUserName(state) {
      return state.user ? state.user.attributes.email.split('@')[0] : '';
    },
    getUserEmail(state) {
      return state.user ? state.user.attributes.email : '';
    },
    getIsAdmin(state) {
      return state.isAdmin;
    },
    getUserSetting(state) {
      return state.userSettings;
    },
    getDatabaseDragging(state) {
      return state.isDatabaseDragging;
    },
    getUserId(state) {
      return state.user ? state.user.username : '';
    },
    getDatabaseList(state) {
      return state.databaseList;
    },
  },
  mutations: {
    clearStore() {
      store.replaceState(initialState);
    },
    setUser(state, user) {
      state.user = user;
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setUserSettings(state, userSettings) {
      state.appSettings.settings = userSettings;
    },
    setUserSettingsDB(state, userSettings) {
      state.userSettings = userSettings;
    },
    addFlow(state, flows) {
      state.flows = flows;
    },
    addFlowPermission(state, addNewFlowPermission) {
      state.addNewFlowPermission = addNewFlowPermission;
    },
    databaseItems(state, database) {
      state.databaseItems[database.name] = database.items;
    },
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    CHANGE_SINGLE_FLOW_NAME(state, flowPayload) {
      state.flows[flowPayload.flowIndex].name = flowPayload.newName;
    },
    SET_USER(state, flowPayload) {
      state.user = flowPayload.user;
    },
    REMOVE_SINGLE_FLOW(state, flowId) {
      state.flows = state.flows.filter((flow) => flow.id != flowId);
    },
    SET_DATABASE_DRAGGING(state, isDrag) {
      state.isDatabaseDragging = isDrag;
    },
    SET_DATABASE_LIST(state, databaseArray) {
      state.databaseList = databaseArray;
    },
    SET_DATABASE_SCHEMA(state, data) {
      state.databaseList.filter((db) => db.name == data.id)[0].schema =
        data.data;
      state.databaseList.filter((db) => db.name == data.id)[0].layout =
        data.layout;
    },
  },
  actions: {
    async updateUserSettings({ commit }, updatedSettings) {
      const response = await updateUserSettingsApi(this.state.user.username, {
        settings: updatedSettings,
      });

      if (
        response.data &&
        response.status === 200 &&
        response.data.HTTPStatusCode === 200
      ) {
        commit('setUserSettingsDB', updatedSettings);
      }
    },
    getUserSettings({ commit }) {
      if (this.state.user) {
        let userSettings = localStorage.getItem(
          this.state.user.username + '.userSettings'
        );
        if (userSettings) commit('setUserSettings', JSON.parse(userSettings));
      }
    },
    async getUserSettingsDB({ commit }) {
      if (this.state.user) {
        var url = process.env.VUE_APP_DATA_API;
        url += '/users/';
        url += this.state.user.username;
        url += '/settings';

        let myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.state.user.signInUserSession.accessToken.jwtToken
        );
        return await fetch(url, { headers: myHeaders, method: 'GET' })
          .then(async (data) => {
            return data.json();
          })
          .then(async (json) => {
            if (json.hasOwnProperty('message'))
              commit('setUserSettingsDB', null);
            else commit('setUserSettingsDB', json);

            return true;
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    async putUserSettings({ commit, state, dispatch }, params) {
      var url = process.env.VUE_APP_DATA_API;
      url += '/users/';
      url += this.state.user.username;
      url += '/settings';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.state.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      let payload = {
        settings: params.settings,
      };

      return await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: myHeaders,
      })
        .then(async (data) => {
          return data.json();
        })
        .then(async (json) => {
          await dispatch('getUserSettingsDB');
          return json;
        });
    },
    getFlows({ commit }) {
      var url = process.env.VUE_APP_DATA_API;
      url += '/flow-list';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.state.user.signInUserSession.accessToken.jwtToken
      );
      return fetch(url, { headers: myHeaders, method: 'GET' })
        .then((data) => data.json())
        .then((flows) => {
          flows.forEach((flow) => {
            if (!flow.hasOwnProperty('tags')) {
              flow['tags'] = [];
            }
          });
          commit('addFlow', flows);

          this.state.isLoading = false;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async createNewFlow({ commit, state, dispatch }, params) {
      var dataType, tasks;

      if (params.type == 'app') {
        dataType = '';

        if (params.navbarElements) {
          const taskSchema = getFlowTaskDataObject();
          taskSchema.props.formTrigger.elements = [...params['navbarElements']];
          tasks = [taskSchema];
        } else {
          tasks = [];
        }
      } else {
        // Set default values for 'timeseries' action
        dataType = params.dataType;
        var fileKey = params.fileKey;
        var itemLabel;
        if (dataType == 'loadprofile') itemLabel = 'timeseries';
        else itemLabel = 'custom';
        tasks = [{ ...getFlowTaskDataObject({ fileKey, itemLabel }) }];
      }

      let flow = {
        id: params.id,
        owner: state.user.username,
        tableID: params.tableID,
        type: params.type,
        dataType: dataType,
        lastExecution: '',
        lastExecutionStatus: true,
        name: 'Flow ' + new Date().toLocaleTimeString(),
        tasks: tasks,
        settings: {
          btnCaption: 'Starten',
          apiEndpoint: '',
          loadingCaption: 'Ladevorgang läuft...',
          fullWidth: false,
          showResultInForm: false,
          brandingColor: '#000',
          domains: ['*.codelos.io'],
          reference: {
            storageOption: '',
            label: '',
            type: '',
            value: '',
          },
          authentication: {
            authUrl: '',
            location: 'header',
            storageOption: '',
            label: '',
            redirectUrl: '',
          },
        },
        tags: [],
      };

      let rslt = await dispatch('saveFlow', {
        flow: flow,
      });

      return rslt;
    },
    // eslint-disable-next-line no-unused-vars
    async saveFlow({ commit, state }, params) {
      //copy of the flow without output and input
      var data = Object.assign({}, JSON.parse(JSON.stringify(params.flow)));
      data.tasks.forEach((part, index, arr) => {
        arr[index].output = [];
        arr[index].input = [];
      });

      //set API params
      let formData = new FormData();
      var url = process.env.VUE_APP_DATA_API;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.state.user.signInUserSession.accessToken.jwtToken
      );

      url += '/flow';
      formData.append('flow', JSON.stringify(data));

      //call api
      return await fetch(url, {
        body: formData,
        headers: myHeaders,
        method: 'put',
      })
        .then(async (response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401)
            throw new Error('Access Token has expired');
          else {
            let jsn = await response.text().then((jsn) => {
              return JSON.parse(jsn)['message'];
            });
            throw jsn;
          }
        })
        .then(async () => {
          return Number(data.id);
        })
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            return 'Access Token has expired';
          } else {
            return 'Error: ' + e;
          }
        });
    },
    fetchFlowAccessLevel({ commit, state }) {
      var url = process.env.VUE_APP_DATA_API;
      url += '/users/' + state.user.username;
      url += '/policies?resource=flows';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + state.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (
            json.policies.length > 0 &&
            json.policies[0].access_level == 'edit'
          ) {
            commit('addFlowPermission', true);
          } else {
            commit('addFlowPermission', false);
          }
        });
    },
    changeSingleFlowNameAction({ commit }, flowPayload) {
      commit('CHANGE_SINGLE_FLOW_NAME', flowPayload);
    },
    setUserDetails({ commit }, flowPayload) {
      commit('SET_USER', flowPayload);
    },
    removeSingleFlowByIdAction({ commit }, flowId) {
      commit('REMOVE_SINGLE_FLOW', flowId);
    },
    async fetchUserDataBase({ commit }) {
      try {
        const fetchUserDatabasesResponse = await getUserDatabases();
        commit('SET_DATABASE_LIST', fetchUserDatabasesResponse.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error :>> ', error);
      }
    },
  },
});

export default store;
